module.exports = __webpack_public_path__ + "img/badge-hd.7ebee731.svg";